import { getBanners } from '~/src/api/content/banners';
import { getTariffs } from '~/src/api/internet';
import {
    SET_BANNER_FOR_INTERNET,
    SET_TARIFFS_FOR_INTERNET,
    SET_TARIFFS_FOR_INTERNET_SELF_ORDER,
} from '~/src/store/actionTypes/internet';

export const getBannerForInternet = (providerId, isAuth) => {
    return async dispatch => {
        await getBanners({ providerId, isAuth, tag: 'internet' })
            .then(response => {
                const banner = response.isSuccess && response.payload.length ? response.payload[0].bannerInfo : null;
                return dispatch(setBannerForInternet(banner));
            })
            .catch(error => console.log(error));
    };
};

export const setBannerForInternet = (bannerData) => ({
    type: SET_BANNER_FOR_INTERNET,
    payload: bannerData,
});

export const getTariffsForInternet = (providerId, isAuth = false, additionalParams) => {

    return async dispatch => {

        await getTariffs(providerId, isAuth, additionalParams)
            .then(response => dispatch(setTariffsForInternet(response.data.items)))
            .catch(error => console.log(error));
    };
};

export const setTariffsForInternet = (tariffs, isSelfOrder) => ({
    type: isSelfOrder ? SET_TARIFFS_FOR_INTERNET_SELF_ORDER : SET_TARIFFS_FOR_INTERNET,
    payload: tariffs,
});

